import { z } from 'zod';

// ── Billing — Stripe Connect schemas (JQ4-35 · US-PAGOS-001) ─────────────────
//
// Zod schemas + TS types for the billing API.
// The access_token MUST NEVER appear in any of these schemas.

// ── StripeConnectionStatusResponse ───────────────────────────────────────────
//
// Returned by GET /billing/stripe/status.
// Two shapes: not-connected (connected: false, optionally onboardingPending) or connected.

export const StripeConnectionStatusResponseSchema = z.discriminatedUnion('connected', [
  z.object({
    connected: z.literal(false),
    // ADR-018: the org started Stripe onboarding but Stripe has not enabled charges yet.
    onboardingPending: z.boolean().optional(),
  }),
  z.object({
    connected: z.literal(true),
    accountName: z.string().optional(),
    livemode: z.boolean(),
  }),
]);

export type StripeConnectionStatusResponse = z.infer<typeof StripeConnectionStatusResponseSchema>;

// ── StartStripeConnectResponse ────────────────────────────────────────────────
//
// The GET /billing/stripe/connect endpoint returns JSON { url } with the
// Stripe authorize URL. This schema represents that response body.
// In practice startStripeConnect() triggers window.location.href navigation.

export const StartStripeConnectResponseSchema = z.object({
  authorizeUrl: z.string().url(),
});

export type StartStripeConnectResponse = z.infer<typeof StartStripeConnectResponseSchema>;

// ── DisconnectStripeResponse ──────────────────────────────────────────────────
//
// Returned by POST /billing/stripe/disconnect.

export const DisconnectStripeResponseSchema = z.object({
  connected: z.literal(false),
});

export type DisconnectStripeResponse = z.infer<typeof DisconnectStripeResponseSchema>;
